<div [class]="(onGetToggleClass | async) + ' toggle'" (click)="onClick()">
    <div [class]="(onGetToggleClass | async) + ' handle'"></div>
</div>